import Handlers from './handlers';

const Toolbar = Handlers();

export default Toolbar;